import React from "react";

// Deterministic tint from the identifier, so a person without a picture still has a
// stable, recognisable colour rather than a grey blank.
const TINTS = [
  "bg-brand-100 text-brand-700", "bg-emerald-100 text-emerald-700",
  "bg-amber-100 text-amber-700", "bg-rose-100 text-rose-700",
  "bg-indigo-100 text-indigo-700", "bg-teal-100 text-teal-700",
];

export default function Avatar({ src, name = "", size = 40, className = "", testid }) {
  const initials = (name || "?").trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
  const tint = TINTS[Math.abs([...name].reduce((a, c) => a + c.charCodeAt(0), 0)) % TINTS.length];
  const style = { width: size, height: size };

  if (src) {
    return (
      <img src={src} alt={name} data-testid={testid} style={style}
           className={`rounded-full object-cover shrink-0 ${className}`} />
    );
  }
  return (
    <div data-testid={testid} style={{ ...style, fontSize: Math.max(11, size * 0.36) }}
         className={`rounded-full grid place-items-center font-semibold shrink-0 ${tint} ${className}`}>
      {initials}
    </div>
  );
}
